export default __webpack_public_path__ + "static/media/rewards.955937d4.svg";